import { useTranslation } from 'react-i18next'

const LanguageSelector = () => {
  const { i18n, t } = useTranslation()

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'ar', label: 'العربية' },
    { code: 'fr', label: 'Français' },
    { code: 'zh-CN', label: '中文 (简体)' },
  ]

  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value)
  }

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="language-selector" className="sr-only">
        {t('selectLanguage')}
      </label>
      <select
        id="language-selector"
        aria-label={t('selectLanguage')}
        value={i18n.resolvedLanguage}
        onChange={handleChange}
        className="bg-white border border-gray-300 text-gray-700 text-sm rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 cursor-pointer"
      >
        {languages.map((lng) => (
          <option key={lng.code} value={lng.code}>
            {lng.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default LanguageSelector
